<template>
    <Spinner v-if="isLoading" />
    <div class="logindiv">
        <div class="logo">
            <img alt="logo" src="@/assets/logo-biomedica-laboratorija.png">
        </div>

	<div class="p-grid nested-grid">
		<div class="p-col-12">

			<div class="card p-fluid customheadercard">
				<div class="p-col-12 customheaderrow">
					<h5 class="stationsHeader">{{ translated('newaccount').toUpperCase() }}</h5>
				</div>												
			</div>		
			<div class="profile-view-left card col-12">
                <div class="p-fluid grid elementGroup">
                    <div class="col-12  sm:col-3 labeldiv">
                        <label :class="{'p-error': v$.name.$invalid && submitted}">{{ translated('name') }} </label>
                    </div>
                    <div class="col-12 sm:col-9">
                        <InputText type="text" v-model="name"/>
                    </div>                
                </div>
                <div class="p-fluid grid elementGroup">
                    <div class="col-12  sm:col-3 labeldiv">
                        <label :class="{'p-error': v$.surname.$invalid && submitted}">{{ translated('surname') }} </label>
                    </div>
                    <div class="col-12 sm:col-9">
                    <InputText type="text" v-model="surname"/>
                    </div>
                </div>

            <div class="p-fluid grid elementGroup">
                <div class="col-12  sm:col-3 labeldiv">
                    <label :class="{'p-error': v$.personalregistrationnumber.$invalid && submitted}">{{ translated('personalregistrationnumber') }} </label>
                </div>
                <div class="col-12 sm:col-9">
                    <InputText type="text" v-model="personalregistrationnumber" @keyup="JMBGKeyDown" />                    
                </div>
            </div>
            
            <div class="p-fluid grid elementGroup">
                <div class="col-12  sm:col-3 labeldiv">
                    <label :class="{'p-error': v$.personBirthDate.$invalid && submitted}">{{ translated('birthday') }} </label>
                </div>
                <div class="col-12 sm:col-9">
                    <!-- <InputText type="text" v-model="personalregistrationnumber"/> -->
                    <Calendar disabled inputId="icon" v-model="personBirthDate" :showIcon="true" dateFormat="dd-mm-yy" :minDate="new Date(1920, 0, 1)"/>  
                </div>
            </div>

            <div class="p-fluid grid elementGroup">
                <div class="col-12  sm:col-3 labeldiv">
                    <label :class="{'p-error': v$.parentName.$invalid && submitted}">{{ translated('parentName') }} </label>
                </div>
                <div class="col-12 sm:col-9">
                    <InputText class="col-12 md:col-9" type="text" v-model="parentName"/>
                </div>
            </div>
            <div class="p-fluid grid elementGroup">
                <div class="col-12  sm:col-3 labeldiv">
                    <label :class="{'p-error': v$.gender.$invalid && submitted}">{{ translated('gender') }} </label>
                </div>
                <div class="col-12 sm:col-9">
                    <Dropdown v-model="gender" disabled :options="genders" optionLabel="name" optionValue="id"/>		
                </div>
            </div>
            <div class="p-fluid grid elementGroup">
                <div class="col-12  sm:col-3 labeldiv">
                    <label :class="{'p-error': v$.email.$invalid && submitted}">{{ translated('email') }} </label>
                </div>
                <div class="col-12 sm:col-9">
                    <InputText type="text" v-model="email"/>
                </div>
            </div> 
            <div class="p-fluid grid elementGroup">
                <div class="col-12  sm:col-3 labeldiv">
                    <label :class="{'p-error': v$.address.$invalid && submitted}">{{ translated('address') }} </label>
                </div>
                <div class="col-12 sm:col-9">
                    <InputText type="text" v-model="address"/>
                </div>
            </div>

            <div class="p-fluid grid elementGroup">
                <div class="col-12  sm:col-3 labeldiv">
                    <label :class="{'p-error': v$.zip.$invalid && submitted}">{{ translated('zip') }} </label>
                </div>
                <div class="col-4 sm:col-3">
                    <InputText type="text" v-model="zip" :useGrouping="false"/>
                </div>
                <div class="col-8 sm:col-6">
                    <InputText type="text" v-model="city"/>
                </div>
            </div>


            <div class="p-fluid grid elementGroup">
                <div class="col-12  sm:col-3 labeldiv">
                    <label>{{ translated('area') }} </label>
                </div>
                <div class="col-12 sm:col-9">
                    <Dropdown :disabled="locked || areaDisabled" v-model="selectedArea" :options="areas" optionLabel="name" optionValue="id" />		
                </div>
            </div>

            <div class="p-fluid grid elementGroup">
                <div class="col-12  sm:col-3 labeldiv">
                    <label :class="{'p-error': v$.selectedCountry.$invalid && submitted}">{{ translated('country') }} </label>
                </div>
                <div class="col-12 sm:col-9">
                    <Dropdown v-model="selectedCountry" :options="countries" optionLabel="name" optionValue="id" />		
                </div>
            </div>

            <div class="p-fluid grid elementGroup">
                <div class="col-12  sm:col-3 labeldiv">
                <label :class="{'p-error': (v$.mobilephone.$invalid) && submitted }">{{ translated('mobilephone') }} </label>
                </div>
                <div class="col-12 sm:col-9">
                    <InputText type="text" v-model="mobilephone"/>
                </div>
            </div>
        
        </div>
            <div v-if="Errors && !IsDirty" class="p-fluid">               
                <div v-for="napaka in Errors" class="p-field p-grid errorplaceholder" :key="napaka">
                    <span class="p-col-12">{{ napaka }}</span>
                </div>											
            </div>


			<div class="p-fluid">
				<div class="p-col-12 submitplaceholder">
					<Button class="submitbtn" :label="translated('register')" @click="handleSubmit(!v$.$invalid)"/>
				</div>												
			</div>         	

		</div>

 		

	</div>
        <Dialog class="registrationDialog" v-model:visible="openRegistrationModal" modal :header="translated('registration')" :style="{ width: '30vw' }" :breakpoints="{ '960px': '50vw', '641px': '100vw' }">
            <p>
            Na vašu e-mail adresu poslat je registracioni link. Klikom na link aktiviraćete svoj nalog i moći ćete da pristupite registraciji
            </p>
            <template #footer>
                <Button :label="translated('setpass')" icon="pi pi-check" @click="openRegistrationModal=false,redirectToLogin()" autofocus class="submitDialogbtn" />
            </template>
        </Dialog>
        <Dialog class="registrationErrorsDialog" v-model:visible="openRegistrationErrorsModal" modal :header="translated('error')" :style="{ width: '30vw' }" :breakpoints="{ '960px': '50vw', '641px': '100vw' }">
            <p>Poštovani, prijavljivanje nije uspelo zbog:</p>
                <div class="errors col-12" v-for="x in this.registrationErrors " :key="x">
                    <p class="errorMessage">{{modifyError(x)}}</p>
                </div>
                <br>
            <p>Molimo proverite podatke i pokušajte ponovo.</p>
            <template #footer>
                <Button :label="translated('backtomainscreen')" icon="pi pi-chevron-left" @click="openRegistrationErrorsModal=false" autofocus class="submitDialogbtn" />
            </template>
        </Dialog>

    </div>  
</template>

<script>
import { email, required, sameAs, between, numeric, minLength, maxLength, requiredUnless, requiredIf, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

import createHttp from "@/services/http";
import router from "@/router";
import { computed } from "vue";
import store from "@/store";
import Dropdown from 'primevue/dropdown';
import Spinner from "@/components/Spinner.vue"
import Calendar from 'primevue/calendar';

const davcna = (value) => (value.match(/^[A-Z]{2}[0-9]{8}$/) == value);

export default {
    setup: () => ({ v$: useVuelidate() }),
    components: { Dropdown, Spinner, Calendar },     
    data() {
        return {
            isLoading: false,
            name: '',
            surname: '',
            personalregistrationnumber: '',
            personBirthDate: null,
            email: '',
            address: '',
            zip: '',
            city: '',
            country: '',
            mobilephone: '',
            IsOperator: false,
            IsServiceProvider: false,
            Email: '',
            Password: '',
            RPassword: '',
            NameSurname: '',
            Errors: [],
            IsDirty: true,
            translated: computed(() => store.getters.getTranslate),
            submitted: false,
            countries: [],
            areas: [],
            selectedCountry: '',
            selectedArea: '',
            openRegistrationModal: false,
            registrationErrors: [],
            openRegistrationErrorsModal: false,
            parentName: '',
            genders: [{ id: 0, name: 'Muško' }, { id: 1, name: 'Žensko' }],
            gender: ''
        }
    },
    validations() {              
        let myvalidations = {
            name: { required },
            surname: { required },
            personalregistrationnumber: { required, numeric, minLength: minLength(13), maxLength: maxLength(13) },
            personBirthDate:{ required },
            email:{ required, email },
            address:{ required },
            zip: { numeric, minLength: minLength(5), maxLength: maxLength(5), required },
            city: { required },            
            mobilephone: { required },
            selectedCountry: {required, minLength: minLength(10) },
            parentName: { required },
            gender: { required }
        };        

        return myvalidations;
    },    
    async mounted() {

        debugger;
        const http = createHttp(false);
        // // console.log(process.env.VUE_APP_API_FOLDER + "/GetCountriesAndAreas");
        const result1 = await http.get(process.env.VUE_APP_API_FOLDER + "/GetCountriesAndAreas");

        if(result1.status==200){
            this.countries = result1.data.countries;
            this.areas = result1.data.areas;

            const myCountry = this.countries.find(x => x.name.toLowerCase() == 'srbija');
            this.selectedCountry = myCountry.id;
        }

        // const http = createHttp(false); 
        // const result = await http.get(process.env.VUE_APP_API_FOLDER + "/getCountries");

        // if(result.status==200){
        //     this.countries = result.data
        //     // console.log('COUTRIES !!!!!!!!')
        //     // console.log(this.countries)
        // }

    },    
    methods: {
        tipkam() {
            this.IsDirty = true;
        },
        async handleSubmit(isFormValid) {

            // console.log('a je enako: ');
            // console.log(isFormValid);
            // console.log('ni enako');

            this.submitted = true;
            
            if (!isFormValid) {
                return;
            }

            this.isLoading = true;

            this.Errors = [];
            this.IsDirty = false;
            // console.log('klicem submit')
        
            let CompanyRegister = {
                id: '00000000-0000-0000-0000-000000000000',
                name: this.name,
                surname: this.surname,
                personalregistrationnumber: this.personalregistrationnumber,
                email: this.email,
                address: this.address,
                zip: this.zip,
                city: this.city,
                countryid: this.selectedCountry,
                mobilephone: this.mobilephone,
                parentName: this.parentName,
                gender: this.gender,
                birthDay: this.personBirthDate,
                muncipalityId: this.selectedArea
            }

            const http = createHttp(false); 
            try {
                // console.log(process.env.VUE_APP_AUTH_FOLDER + "/register");
                http.post(process.env.VUE_APP_AUTH_FOLDER + "/register", CompanyRegister)
                    .then((response) => { 
                        // console.log('OK response');
                        // console.log(response);
                        if(response.data.status=="ERROR"){
                            this.registrationErrors = response.data.errors;
                            // console.log(this.registrationErrors);
                            this.openRegistrationErrorsModal=true;
                        } else {
                            this.openRegistrationModal=true;
                        }

                        this.isLoading = false;
                    })
                    .catch((error) => {
                        const myErr = {...error};

                        // console.log('ERROR');
                        // console.log(myErr) 
                        this.Errors = myErr.response.data.Errors;
                        this.isLoading = false;
                        
                })
            } catch (error) {
                // console.log(error);
                this.isLoading = false;
            }

            
            
        },
        redirectToLogin() {
            router.push("login");
        },
        modifyError(value){
            return value.split('|')[0];
        },
        GetJMBGData(jmbg) {
            // Provera pravilne dužine JMBG-a
            if (jmbg.length !== 13 || !/^\d+$/.test(jmbg)) {
                return {
                error:'JMBG nije validan',
                dan:-1,
                mesec:-1,
                godina:1,
                pol:'UNDEFINED'
            };
            }

            // Izvlačenje datuma rođenja
            const dan = jmbg.substring(0, 2);
            const mesec = jmbg.substring(2, 4);
            let godina = jmbg.substring(4, 7);
            // Dodavanje tačnog veka na osnovu treće cifre godine rođenja
            godina = (godina.charAt(0) === "9" ? "1" : "2") + godina;

            // Izvlačenje pola
            // // console.log('SPOL: ', jmbg.substring(9, 12));

            const bbb = parseInt(jmbg.substring(9, 12), 10);
            const pol = bbb < 500 ? 'M' : 'W';

            return {
                error:'',
                dan,
                mesec,
                godina,
                pol
            };
        },
        JMBGKeyDown() {
            this.JMBGLostFocus();
        },
        JMBGLostFocus() {
            let jmbgData = this.GetJMBGData(this.personalregistrationnumber);
            // console.log(jmbgData);

            if(jmbgData.error == ''){
                
                this.gender = this.genders.find(x => x.id == (jmbgData.pol == 'M' ? 0 : 1)).id;
                this.personBirthDate = new Date(jmbgData.godina, jmbgData.mesec - 1, jmbgData.dan);                                
            } else {
                this.gender = null;
                this.personBirthDate = null;
            }
        }        
    }    
}
</script>


<style scoped>

.submitDialogbtn {
    position: relative;
    top: 50%;
}
.labeldiv { padding-bottom:0px}
.elementGroup { margin-bottom: 10px}
.submitsave{ position: relative; float: right;}
.submitback{ position: relative; float: left;}
.profile-view-left {padding-top: 40px;}
    .errorplaceholder span {
        color:red;
    }

    .errorplaceholder {
        text-align: center;
    }

    .card.p-fluid.customheadercard {
        height: 60px;
    }

    .headercompany, .headeradmin {
        background: linear-gradient(91deg, #044868, #f8f9fa);
        height: 25px;
        color: white;
    }

    .submitplaceholder {
        text-align: center;
    }
    .submitbtn {
        width:120px;
    }
    form {
        background: white;
        padding: 20px;
        border-radius: 0 0 10px 10px;
    }

    .passdiv {
        margin-top:30px;
    }

    form button {
        display: block;
        margin: 60px auto 0;
    }

    .logindiv {
        max-width: 600px;
        margin: 0 auto;
    }

    .errordiv {
        height: 10px;
        padding-top: 40px;
        text-align: center;
    }

    .logindiv .logo {
        background: #f2f2f2;
        padding:10px;
        padding-bottom: 40px;
    }

    .logo img {display: block;margin-left: auto;margin-right: auto;}
    
    .p-col-12.customheaderrow {
        padding-left: 0px;
    }

    h5.stationsHeader {
        font-weight: bolder;
    }

h5.stationsHeader {
    font-size: 1.6em;
    align-self: center;
}

.p-col-12.customheaderrow {
    align-items: center;
    text-align: center;
    color: white;
    padding-top: 4px;
}

.card.p-fluid.customheadercard {
    background: #6c757d;
    border-radius: 0 0 3px 3px;
}    
.errorMessage{
    color:red;
    text-align: center;
    font-weight: bolder;
    font-style: italic;
}
.p-dialog.p-component.registrationDialog .p-dialog-header .p-dialog-header-icons { display:none !important}
</style>